<template>
  <v-row justify="center">
    <v-dialog persistent v-model="confirm.active" max-width="390">
      <v-card>
        <v-card-title v-if="confirm.title">
          <h1 class="headline text-center">
            {{ confirm.title }}
          </h1>
        </v-card-title>
        <v-card-text class="text-body-1" v-if="confirm.body">
          {{ confirm.body }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :color="confirm.confirmColor || 'error'"
            @click.native="onConfirm"
          >
            تأكيد
          </v-btn>
          <v-btn @click.native="onCancel"> تراجع </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  computed: {
    confirm() {
      return this.$store.state.confirm;
    },
  },
  methods: {
    onConfirm() {
      this.confirm.resolve(true);
      this.$store.commit("confirm/SET_DEACTIVATE");
    },
    onCancel() {
      this.confirm.resolve(false);
      this.$store.commit("confirm/SET_DEACTIVATE");
    },
  },
};
</script>
